import {
  CustomerLogo,
  IconEmail,
  GreyGrey60
} from '@sequencehq/core-components'

import { getLogoSrc } from 'Customer/index'
import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { TaskInput } from './types'
import { getGenericNotificationTitle } from './getGenericNotificationTitle'
import { useCustomerData } from '../../hooks/useCustomerData'

export const GenericNotificationListItem = (props: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, statusIcon } =
    useManualTaskListItemContentToolkit<TaskInput>({ taskId: props.taskId })

  const input = manualTask?.input
  const { customer, isPending: isCustomerPending } = useCustomerData(
    input?.customerId
  )

  if (!manualTask || !input || isCustomerPending) {
    return <InboxListItemContent.Loading />
  }

  return (
    <InboxListItemContent
      isSelected={props.isSelected}
      isUnread={props.hideUnreadIndicator ? undefined : isUnread}
      onClick={props.onClick}
      title={getGenericNotificationTitle(input.title, customer?.legalName)}
      description={input.body}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={props.isSelected}>
          {customer ? (
            <CustomerLogo
              src={getLogoSrc(customer)}
              size={24}
              fallbackSize={16}
            />
          ) : (
            <IconEmail color={GreyGrey60} />
          )}
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
